import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormPatchIcon.tsx
const MedFormPatchIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "patch-icon.svg",
		alt: t("medicationForm.patch")
	});
};

//#endregion
export { MedFormPatchIcon };